import React, { createContext, useContext, useEffect, useState } from 'react';
import { authStateListener, login, logout, signup } from '../networking/AuthCalls';
import { getUserProfile } from '../networking/DashCalls';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = authStateListener((user) => {
            const loadProfile = async () => {
                if (user) {
                    try {
                        const profile = await getUserProfile(user.uid);
                        setCurrentUser({ ...user, ...profile });
                        console.log('%c[AUTH STATUS] User profile loaded:', 'color: green; font-weight: bold;', profile);
                    } catch (error) {
                        console.error('[AUTH ERROR] Failed to fetch user profile:', error);
                        setCurrentUser(user); // Fallback to auth user only
                    }
                } else {
                    setCurrentUser(null);
                }
                setLoading(false);
            };

            loadProfile();
        });

        return unsubscribe;
    }, []);

    const handleLogin = (email, password) => {
        console.log('%c[AUTH ACTION] Attempting to log in...', 'color: blue; font-weight: bold;');
        return login(email, password);
    };

    const handleLogout = () => {
        console.log('%c[AUTH ACTION] Logging out...', 'color: orange; font-weight: bold;');
        return logout();
    };

    const handleSignup = (email, password) => {
        console.log('%c[AUTH ACTION] Attempting to sign up...', 'color: purple; font-weight: bold;');
        return signup(email, password);
    };

    const value = {
        currentUser,
        login: handleLogin,
        logout: handleLogout,
        signup: handleSignup,
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};